import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=fb732c48&scoped=true"
import script from "./persona.vue?vue&type=script&lang=js"
export * from "./persona.vue?vue&type=script&lang=js"
import style0 from "./persona.vue?vue&type=style&index=0&id=fb732c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb732c48",
  null
  
)

export default component.exports